<template>
  <div class="section" >
    <!-- PAGE TITLE -->
    <!-- page intro -->
    <!-- <p class="mb-1">{{ $t('ui.paymentLastStepIntroInfo') }}</p> -->
    <p  class="subtitle is-4 has-text-weight-semibold mb-1">{{ $t('ui.reviewEventRules') }}</p>
    <p class="mb-1-half">{{ $t('ui.checkYourPurchaseWarning') }}</p>
    <!-- event info -->

    <!-- EVENT RULES -->
    <div class="media ">
      <div class="content">
        <h3
          class="title is-6 has-text-weight-semibold  has-text-grey-dark mb-1"
        >{{ $t('ui.eventRules')}}</h3>
        <ul class="">
          <li v-for="rule in $store.state.user.displayedEvent.details.eventRules" :key="rule.id">{{ rule.value.tr }}</li>
        </ul>
      </div>
    </div>
    <!-- ./EVENT RULES -->
  </div>
</template>

<script>

export default {
  // props: {
  //   eventRules: {
  //     type: Array,
  //     required: true
  //   }
  // }
};
</script>
